import { render, staticRenderFns } from "./CurrencyList.vue?vue&type=template&id=58d70c73&scoped=true"
import script from "./CurrencyList.vue?vue&type=script&lang=js"
export * from "./CurrencyList.vue?vue&type=script&lang=js"
import style0 from "./CurrencyList.vue?vue&type=style&index=0&id=58d70c73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d70c73",
  null
  
)

export default component.exports